module.exports = __webpack_public_path__ + "img/061-saba-island.7467f218.svg";